<template>
<div class="employeeslist">
    <div class="main-wrapper">
        <layout-header></layout-header>
        <layout-sidebar></layout-sidebar>
        <!-- Page Wrapper -->
        <div class="page-wrapper">
            <!-- Page Content -->
            <div class="content container-fluid">
                <!-- Page Header -->
                <div class="page-header">
                    <div class="row align-items-center">
                        <div class="col">
                            <h3 class="page-title">Transfered Employees</h3>
                            <ul class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/index">Dashboard</router-link>
                                </li>
                                <li class="breadcrumb-item active">Transfered Employees</li>
                            </ul>
                        </div>
                        <div class="col-auto float-right ml-auto">
                            <a class="btn add-btn" @click="openDialog" v-if="currentUser.roles.includes('HCPM') || currentUser.roles.includes('HRAdmin')"><i class="fa fa-plus"></i> Transfer Employee</a>
                        </div>
                    </div>
                </div>

                <!----Datatable-->
                <div class="row">
                    <div class="col-md-12">
                        <v-data-table :headers="headers" :items="transferedEmployees" sort-by="" class="elevation-1">
                            <template v-slot:[`item.dateJoined`]="{ item }">
                                {{
                    item.dateJoined
                      ? new Date(item.dateJoined).toLocaleDateString()
                      : ""
                  }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <div class="dropdown dropdown-action">
                                    <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="material-icons">more_vert</i></a>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item" @click="setTransferStatus(item)" v-if="
                          item.approvedByHOD !== null &&
                            item.status == 0 &&
                            currentUser.roles.includes('HRAdmin')
                        "><i class="fa fa-pencil m-r-5"></i> Approve or Reject</a>
                                        <a class="dropdown-item" @click="openConfirm(item)" v-if="
                            item.status == 1 &&
                            currentUser.roles.includes('HRAdmin')
                        "><i class="fa fa-pencil m-r-5"></i> Confirm</a>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:[`item.profile`]="{ item }">
                                <h2 class="table-avatar blue-link">
                                    <router-link :to="{
                        name: 'employeedetail',
                        params: { id: item.employee.id }
                      }" class="avatar"><img alt="" src="~@/assets/profiles/avatar-02.jpg" v-if="!item.employee.passportPhoto" />
                                        <img alt="" :src="media + item.employee.passportPhoto" width="38" v-if="item.employee.passportPhoto" /></router-link>
                                    <router-link :to="{
                        name: 'employeedetail',
                        params: { id: item.employee.id }
                      }">{{
                        `${item.employee.firstName} ${item.employee.lastName}`
                      }}</router-link>
                                </h2>
                            </template>
                            <template v-slot:[`item.stat`]="{ item }">
                                <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 0 && item.approvedByHOD == null" aria-expanded="false">
                                    <i class="fa fa-dot-circle-o text-purple"></i> New
                                </a>
                                <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 0 && item.approvedByHOD != null" aria-expanded="false">
                                    <i class="fa fa-dot-circle-o text-purple"></i> Awaiting HR
                                    Approval
                                </a>
                                <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 1" aria-expanded="false">
                                    <i class="fa fa-dot-circle-o text-success"></i> Approved
                                </a>
                                <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 10" aria-expanded="false">
                                    <i class="fa fa-dot-circle-o text-success"></i> Confirmed
                                </a>
                                <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 2" aria-expanded="false">
                                    <i class="fa fa-dot-circle-o text-danger"></i> Declined
                                </a>
                            </template>
                        </v-data-table>
                    </div>
                </div>
                <!---/Datatable-->
            </div>

            <!-- HR approve dialog -->

            <v-dialog v-model="dialogStatus" max-width="500px">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="form-header">
                            <h3>Employee Transfer</h3>
                            <p>Are you sure want to approve for this transfer?</p>
                        </div>
                        <div class="modal-btn delete-action">
                            <div class="row">
                                <div class="col-6">
                                    <a @click="changeLeaveStatus(1)" class="btn btn-primary continue-btn">Approve</a>
                                </div>
                                <div class="col-6">
                                    <a @click="changeLeaveStatus(2)" data-dismiss="modal" class="btn btn-primary cancel-btn">Decline</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-dialog>
            <!-- HR approve dialog ends -->
            <!-- HR approve dialog -->

            <v-dialog v-model="dialogConfirm" max-width="500px">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="form-header">
                            <h3>Employee Transfer</h3>
                            <p>Can you confirm this employee have resume his/her new office?</p>
                        </div>
                        <div class="modal-btn delete-action">
                            <div class="row">
                                <div class="col-6">
                                    <a @click="confirmTransfer()" class="btn btn-primary continue-btn">Confirm</a>
                                </div>
                                <div class="col-6">
                                    <a @click="closeConfirm()" data-dismiss="modal" class="btn btn-primary cancel-btn">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-dialog>
            <!-- HR approve dialog ends -->

            <!-- Add Employee Modal -->
            <v-dialog v-model="dialogAdd" max-width="725px">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Transfer Employee</h5>
                        <button type="button" class="close" @click="close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="addTransferedEmployee">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="error">
                                        <strong>Error!</strong> {{ error }}
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="message">
                                        <strong>Success!</strong> {{ message }}
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Select Employee:</label>
                                    <multiselectvue class="from-control" v-model="employeeDetails" placeholder="Select one" :custom-label="nameOfEmployee" :options="sortedEmployeeNames" :searchable="true" @select="optionSelected" :allow-empty="false">
                                        <template slot="singleLabel" slot-scope="{ option }">{{ option.firstName }} {{ option.lastName }}</template>
                                    </multiselectvue>
                                </div>

                                <div class="row col-12">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Business Unit From:</label>
                                            <div class="form-control">
                                                {{ companydetails.name }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Business Unit To:
                                                <span class="text-danger">*</span></label>
                                            <select class="form-control" v-model="companyunitIdTo">
                                                <option disabled>Select Business Unit</option>
                                                <option v-for="item in units" :key="item.id" :value="parseInt(item.id)">
                                                    {{ item.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>
                                                From Designation
                                            </label>

                                            <div class="form-control">
                                                {{ designationName.name }}
                                            </div>

                                            <!-- <multiselectvue
                          class="from-control"
                          v-model="newDepartments"
                          placeholder="Select Department"
                          :custom-label="nameOfDepartments"
                          :options="sortedEmployeeDepartments"
                          :searchable="true"
                          @select="optionSelectDepartment"
                          :allow-empty="false"
                        >
                          <template slot="singleLabel" slot-scope="{ option }"
                            >{{ option.name }}
                          </template>
                        </multiselectvue> -->
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>
                                                To Designation
                                                <span class="text-danger">*</span></label>

                                            <multiselectvue class="from-control" v-model="newDesignationId" placeholder="Select Designation" :custom-label="nameOfDesignation" :options="designations" :searchable="true" @select="optionSelectDesignation" :allow-empty="false">
                                                <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                                            </multiselectvue>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>
                                                From Level
                                            </label>

                                            <div class="form-control">
                                                {{ rankName.rankName }}
                                            </div>

                                            <!-- <multiselectvue
                          class="from-control"
                          v-model="newDepartments"
                          placeholder="Select Department"
                          :custom-label="nameOfDepartments"
                          :options="sortedEmployeeDepartments"
                          :searchable="true"
                          @select="optionSelectDepartment"
                          :allow-empty="false"
                        >
                          <template slot="singleLabel" slot-scope="{ option }"
                            >{{ option.name }}
                          </template>
                        </multiselectvue> -->
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>
                                                To Level
                                                <span class="text-danger">*</span></label>

                                            <multiselectvue class="from-control" v-model="newRankId" placeholder="Select Level" :custom-label="nameOfRank" :options="ranks" :searchable="true" @select="optionSelectRank" :allow-empty="false">
                                                <template slot="singleLabel" slot-scope="{ option }">{{ option.rankName }}</template>
                                            </multiselectvue>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group wrapper-class">
                                            <label>Effective Date
                                                <span class="text-danger">*</span></label>
                                            <div class="cal-icon">
                                                <!-- <datepicker
                            v-model="dateJoined"
                            calendar-class
                            input-class
                            bootstrap-styling
                            class="form-control datetimepicker"
                            type="date"
                          /> -->
                                                <input class="form-control" v-model="dateJoined" type="date" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="col-form-label">Employee Code </label>
                                            <input class="form-control" v-model="employeeCode" type="text" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" type="submit" :disabled="submitted">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </v-dialog>

            <!-- /Add Employee Modal -->
            <!-- /Page Content -->
        </div>
        <!-- /Page Wrapper -->
    </div>
</div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import {
    required,
    numeric,
    sameAs
} from "vuelidate/lib/validators";
import {
    employeeService
} from "@/services/employeeService.js";
import {
    authenticationService
} from "@/services/authenticationService";
import {
    organizationService
} from "@/services/organizationService";
import Datepicker from "vuejs-datepicker";
export default {
    components: {
        LayoutHeader,
        LayoutSidebar,
        Datepicker
    },
    data() {
        return {
            company: authenticationService.currentOfficeValue,
            currentUser: authenticationService.currentUserValue,
            requestDate: new Date(),
            media: "data:image/jpeg;base64,",
            headers: [{
                    text: "Employee",
                    align: "start",
                    value: "profile"
                },
                {
                    text: "From Bus. Unit",
                    value: "fromUnit.name"
                },
                {
                    text: "From Position",
                    value: "fromDesignation.name"
                },
                {
                    text: "From Level",
                    value: "fromRank.rankName"
                },
                {
                    text: "To Bus.Unit",
                    value: "toUnit.name"
                },
                {
                    text: "To Position",
                    value: "toDesignation.name"
                },
                {
                    text: "To Level",
                    value: "toRank.rankName"
                },
                {
                    text: "Effective Date",
                    value: "dateJoined"
                },
                {
                    text: "Status",
                    value: "stat"
                },
                {
                    text: "Action",
                    value: "actions",
                    sortable: false
                },
            ],
            transferedEmployees: [],
            employees: [],
            transfer: {},
            message: "",
            units: [],
            designations: [],
            ranks: [],
            dialogStatus: false,
            dialogConfirm: false,
            submitted: false,
            loading: false,
            companyunitIdTo: "",
            companyunitIdFrom: "",
            toDepartmentId: "",
            newDepartments: "",
            toDesignationId: "",
            toRankId: "",
            newDesignationId: "",
            newRankId: "",
            dateJoined: new Date().toDateString(),
            employeeName: 0,
            employeeDetails: {},
            currentUserFullName: "",
            employeeCode: '',
            error: "",
            dialogAdd: false,
            companydetails: {},
            designationName: {},
            rankName: {}
        };
    },

    computed: {
        sortedEmployeeNames: function () {
            function compare(a, b) {
                if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) return -1;
                if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
                return 0;
            }

            return this.employees ? this.employees.sort(compare) : this.employees;
        }

        // sortedEmployeeDesignation: function() {
        //   function compare2(a, b) {
        //     if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        //     if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        //     return 0;
        //   }

        //   return this.designations.sort(compare2);
        // }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        }
        // dialogEdit(val) {
        //   val || this.closeEdit();
        // },
    },
    created() {
        this.getCurrentUser();
        this.GetUnits();
        this.GetEmployees();
        this.GetRanks();
        this.getDesignations();
        this.getDepartments();
        this.GetTransferedEmployees();
    },

    methods: {
        // multiselect for employee list
        nameOfEmployee({
            firstName,
            lastName
        }) {
            return `${firstName} ${lastName}`;
        },

        optionSelected(option, id) {
            console.log('employees:', option.id, this.employeeDetails);
            this.designationName = option.designation;
            this.rankName = option.rank;
            this.employeeName = option.id;
            this.employeeCode = option.employeeCode;
        },

        // multiselect for department list
        nameOfDepartments({
            name
        }) {
            return `${name}`;
        },

        optionSelectDepartment(option) {
            this.toDepartmentId = option.id;
            console.log(option.id, this.toDepartmentId);
        },

        // multiselect for designation list

        nameOfDesignation({
            name
        }) {
            return `${name}`;
        },

        optionSelectDesignation(option, id) {
            console.log(option.id, this.newDesignationId.id);
            this.toDesignationId = this.newDesignationId.id;
        },

        nameOfRank({
            rankName
        }) {
            return `${rankName}`;
        },

        optionSelectRank(option, id) {
            console.log(option.id, this.newRankId.id);
            this.toRankId = this.newRankId.id;
        },

        GetEmployees() {
            this.loading = true;
            var unit = JSON.parse(localStorage.getItem("companyUnit"));
            employeeService.getEmployees(unit.id).then(
                model => {
                    this.employees = model;
                },
                error => {
                    this.error = error;
                    this.loading = false;
                }
            );
        },

        sortDesignations() {
            this.designations.sort(function (a, b) {
                let x = a.name.toLowerCase();
                let y = b.name.toLowerCase();
                if (x < y) {
                    return -1;
                }
                if (x > y) {
                    return 1;
                }
                return 0;
            });
        },

        GetTransferedEmployees() {
            this.loading = true;
            var unit = JSON.parse(localStorage.getItem("companyUnit"));
            employeeService.GetTransferedEmployees(unit.id).then(
                model => {
                    this.transferedEmployees = model;
                },
                error => {
                    this.error = error;
                    this.loading = false;
                }
            );
        },

        GetUnits() {
            organizationService.getCompanyUnits(this.company.id).then(
                model => {
                    this.units = model;

                    var unitStrings = "";
                    model.forEach(t => {
                        unitStrings += t.id + " - " + t.name + ", ";
                    });
                    this.unitStrings = unitStrings;
                },
                error => {
                    this.error = error;
                }
            );
        },
        GetRanks() {
            organizationService.getRanks().then(
                model => {
                    this.ranks = model;
                },
                error => {
                    this.error = error;
                }
            );
        },
        changeLeaveStatus(status) {
            this.submitted = true;
            this.transfer.status = status;
            this.transfer.approvedDate = new Date();
            this.transfer.approvedBy = this.currentUser.employee.id
            const id = this.transfer.id;
            this.loading = true;
            employeeService.updateTransferedEmployee(id, this.transfer).then(
                id => {
                    var unit = JSON.parse(localStorage.getItem("companyUnit"));
                    employeeService.GetTransferedEmployees(unit.id).then(model => {
                        this.transferedEmployees = model;
                        this.dialogStatus = false;
                    });
                },
                error => {
                    this.error = error;
                    this.dialogStatus = false;
                    this.loading = false;
                }
            );
        },
        confirmTransfer() {
            this.submitted = true;
            const id = this.transfer.id;
            this.transfer.status = 10;
            this.loading = true;
            employeeService.confirmTransferedEmployee(id, this.transfer).then(
                id => {
                    var unit = JSON.parse(localStorage.getItem("companyUnit"));
                    employeeService.GetTransferedEmployees(unit.id).then(model => {
                        this.transferedEmployees = model;
                        this.dialogConfirm = false;
                    });
                },
                error => {
                    this.error = error;
                    this.dialogStatus = false;
                    this.loading = false;
                }
            );
        },

        getCurrentUser() {
            let currentUser = JSON.parse(localStorage.getItem("currentUser"));
            this.companydetails = JSON.parse(localStorage.getItem("companyUnit"));
            this.companyunitIdFrom = this.companydetails.id;
            this.currentUserId = currentUser.employee;
            this.currentUserFullName =
                currentUser.employee.firstName + " " + currentUser.employee.lastName;
        },

        addTransferedEmployee() {
            if (this.currentUser.roles.includes('HRAdmin')) {
                var data = {
                    employeeId: this.employeeName,
                    fromUnitId: this.currentUser.employee.companyUnitId,
                    toUnitId: this.companyunitIdTo,
                    toDesignationId: this.toDesignationId,
                    fromDesignationId: this.designationName.id,
                    toRankId: this.toRankId,
                    fromRankId: this.rankName.id,
                    employeeCode: this.employeeCode,
                    dateJoined: this.dateJoined,
                    status: 1
                }
            } else {
                var data = {
                    employeeId: this.employeeName,
                    fromUnitId: this.currentUser.employee.companyUnitId,
                    toUnitId: this.companyunitIdTo,
                    toDesignationId: this.toDesignationId,
                    fromDesignationId: this.designationName.id,
                    toRankId: this.toRankId,
                    fromRankId: this.rankName.id,
                    employeeCode: this.employeeCode,
                    dateJoined: this.dateJoined,
                    status: 0
                }
            }
            employeeService
                .addTransferedEmployee(data)
                .then(() => {
                    this.submitted = true
                    alert("Employee transfered successfully")
                    this.message = "Employee transfered successfully";
                    this.GetTransferedEmployees();
                    this.close();
                }, e => {
                    this.submitted = false
                });
        },

        close() {
            this.dialogAdd = false;
            this.clearModel();
        },

        clearModel() {
            this.employeeDetails = "";
            this.companyunitIdTo = "";
            this.companyunitIdTo = "";
            this.newDesignationId = "";
            this.designationName.id = "";
            this.dateJoined = new Date().toDateString();
            // this.companydetails = {};
            this.designationName = {};
            this.rankName = {};
            this.error = "";
            this.message = "";
            this.submitted = false;
        },

        openDialog() {
            this.dialogAdd = true;
            this.sortDesignations();
        },
        closeStatus() {
            this.dialogStatus = false;
            this.clearModel();
        },
        closeConfirm() {
            this.dialogConfirm = false;
        },
        openConfirm(item) {
            this.transfer = item;
            this.dialogConfirm = true;
        },
        setTransferStatus(item) {
            this.transfer = item;
            this.dialogStatus = true;
        },

        getDesignations() {
            organizationService.getDesignations().then(
                model => {
                    this.designations = model;
                    // console.log(model);
                },
                error => {
                    error = error;
                }
            );
        },
        getDepartments() {
            organizationService.getDepartments().then(
                model => {
                    this.departments = model;
                    // console.log(model);
                },
                error => {
                    error = error;
                }
            );
        }
    },

    name: "employeeslist"
};
</script>



// WEBPACK FOOTER //
// src/components/employees/HRemployeeTransfer.vue